class BestVenues {
	constructor(container) {
		this.container = container
		this.bestVenues = []
	}

	setBestVenues(bestVenues) {
		const latestBestVenuesLength = this.bestVenues.length
		this.itsEmpty(bestVenues)
		this.render(bestVenues.slice(latestBestVenuesLength))
		this.bestVenues = bestVenues
	}

	itsEmpty(bestVenues) {
		if (bestVenues.length + this.bestVenues.length === 0) {
			this.renderEmptyView()
		}
	}

	renderEmptyView() {
		this.container.innerHTML = /* html */ `
		<div class="col-12">
			<div class="venues-detail__not-found">
			<h3 class="h1">No Matching Venues</h3>
			<p class="">
				Let us know what you are looking for and our venue expert will contact you shortly.
			</p>
			<div>
				<i class="material-icons mr-xl-1">email</i>
				<span id="cloak99370da34ed63f2bae248fb71af0f0f5">
					<a href="mailto:info@bestvenuesnewyork.com">info@bestvenuesnewyork.com</a>
				</span>
			</div>
			<div>
			<i class="material-icons mr-xl-1">phone</i><a href="tel:(212) 969-9804">(212) 969-9804</a>
				</div>

			<a href="index.php?option=com_content&view=article&id=1&Itemid=180" class="btn btn-secondary mt-2">Contact us</a>
			</div>
		</div>
		`
	}

	clear() {
		this.bestVenues = []
		this.container.innerHTML = ''
	}

	render(bestVenues) {
		bestVenues.forEach(bestVenue => {
			this.container.innerHTML += this.makeBestVenuesn(bestVenue)
		})
	}
	setBadgeColor(array) {
		const colors = ["#eeeeee", "#bcbcbc", "#cfd8dc", "#9ea7aa"];
		const listOfCategory = array.map(e => {
			const index = Math.floor(Math.random() * colors.length);
			return `
			<span style="background-color:${colors[index]}; color:black" class="badge badge-flex px-xl-1">
			${e}
			</span>
			`
		});
		return listOfCategory;
	}

	makeBestVenuesn (bestVenue) {
		return /* html */ `
		<div class="col-12 col-md-6 col-xl-4 mb-2">
			<a class="venues-detail__item" href="${bestVenue.link}" title="${bestVenue.title}">
				<div class="row pb-1">
					<div class="col-12">
						<img class="img-fluid" src="${bestVenue.images.image_intro}" title="${bestVenue.title}" alt="${bestVenue.title}" />
					</div>
					<div class="col-12">
						<h4>${bestVenue.title}</h4>
					</div>
					<div class="col-12">
						<div class="row mt-1">
							<div class="col-12">
								<p class="px-2 pt-1" style="display:flex;flex-wrap:wrap;">
									<span class="text-primary font-weight-bold">${bestVenue.neighbourhood}</span>
									<span>
									|
									<i class="large material-icons">group</i>
									${bestVenue['min-capacity']}-${bestVenue['max-capacity-standing']}
									|
									</span>
									<span>
										<i class="large material-icons">event_seat</i>
										${bestVenue['min-capacity']}-${bestVenue['max-capacity-seated']}
										|
									</span>
									${this.setBadgeColor(bestVenue.categoryvenues.split(', '))}
								</p>
							</div>
						</div>
					</div>
				</div>
			</a>
		</div>
		`
	}
}
export default BestVenues



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/async_filters/src/views/BestVenues.js